import { render } from "./ModalTemplate.vue?vue&type=template&id=7812f1ab&ts=true"
import script from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalTemplate.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ModalTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7812f1ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7812f1ab', __exports__)) {
    api.reload('7812f1ab', __exports__)
  }
  
  module.hot.accept("./ModalTemplate.vue?vue&type=template&id=7812f1ab&ts=true", () => {
    api.rerender('7812f1ab', render)
  })

}


export default __exports__